/* eslint-disable */
import { toCurrency } from '../../utils/CurrencyUtil'
import { useMemo, useState, useEffect, useCallback } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Separator } from '../ui/separator'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip'
import { TooltipArrow } from '../ui/tooltip'
import { ArrowUp, ArrowDown, CircleAlert, ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '../ui/button'
import useEmblaCarousel from 'embla-carousel-react'



// const data = {
//     "mainData": [
//         {
//             "schemeCode": "21520",
//             "isincd": "INF879O01019",
//             "folioNo": "17846000",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Parag Parikh Flexi Cap Fund-Reg(G)",
//             "xirr": 3.5,
//             "amcCode": 400049,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "PP001RG-GR",
//             "holding": 990521.0784024,
//             "closerate": 85.1988,
//             "balance": 11625.998000000001,
//             "netInvestedAmt": 974999.9165274486,
//             "netUnits": 11625.998000000001,
//             "absoluteReturn": 1.5919141747449048,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "50096",
//             "isincd": "INF226401026",
//             "folioNo": "3771047281",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Capitalmind Flexi Cap Fund-Reg(G)",
//             "xirr": 6.17,
//             "amcCode": 400067,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "CMFCGP-GR",
//             "holding": 539524.8801504,
//             "closerate": 10.1016,
//             "balance": 53409.844,
//             "netInvestedAmt": 524999.9904600887,
//             "netUnits": 53409.844,
//             "absoluteReturn": 2.766645705570823,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "50096",
//             "isincd": "INF226401026",
//             "folioNo": "3771047345",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Capitalmind Flexi Cap Fund-Reg(G)",
//             "xirr": 6.14,
//             "amcCode": 400067,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "CMFCGP-GR",
//             "holding": 462359.6466912,
//             "closerate": 10.1016,
//             "balance": 45770.932,
//             "netInvestedAmt": 449999.9960614594,
//             "netUnits": 45770.932,
//             "absoluteReturn": 2.7465890528702404,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "50096",
//             "isincd": "INF226401026",
//             "folioNo": "3771047356",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Capitalmind Flexi Cap Fund-Reg(G)",
//             "xirr": 5.87,
//             "amcCode": 400067,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "CMFCGP-GR",
//             "holding": 415938.7035432,
//             "closerate": 10.1016,
//             "balance": 41175.527,
//             "netInvestedAmt": 404999.99995464843,
//             "netUnits": 41175.527,
//             "absoluteReturn": 2.7009144666114713,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "1495",
//             "isincd": "INF109K01761",
//             "folioNo": "40093759/81",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "ICICI Pru Multi-Asset Fund(G)",
//             "xirr": 18.72,
//             "amcCode": 400015,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "DYNMIC",
//             "holding": 283875.1147024,
//             "closerate": 812.6134,
//             "balance": 349.33600000000007,
//             "netInvestedAmt": 262499.9074965579,
//             "netUnits": 349.33600000000007,
//             "absoluteReturn": 8.142938947939387,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "2455",
//             "isincd": "INF204K01562",
//             "folioNo": "477321395304",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Nippon India Large Cap Fund(G)",
//             "xirr": 5.68,
//             "amcCode": 400025,
//             "panNumber": "AIDPP6900B",
//             "legalName": "Nippon India Large Cap Fund",
//             "bseSchemeCode": "EARG",
//             "holding": 370790.5357637,
//             "closerate": 90.0497,
//             "balance": 4117.621,
//             "netInvestedAmt": 339215.30786599754,
//             "netUnits": 4117.621,
//             "absoluteReturn": 9.308314561728421,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "2662",
//             "isincd": "INF204K01GB3",
//             "folioNo": "477426414646",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Nippon India Value Fund(G)",
//             "xirr": 4.9,
//             "amcCode": 400025,
//             "panNumber": "AIDPP6900B",
//             "legalName": "Nippon India Value Fund",
//             "bseSchemeCode": "RELSEGP-GR",
//             "holding": 383236.311535,
//             "closerate": 224.2945,
//             "balance": 1708.63,
//             "netInvestedAmt": 375000.06466608006,
//             "netUnits": 1708.63,
//             "absoluteReturn": 2.1963321196368115,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "2662",
//             "isincd": "INF204K01GB3",
//             "folioNo": "477426417854",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Nippon India Value Fund(G)",
//             "xirr": 5.49,
//             "amcCode": 400025,
//             "panNumber": "AIDPP6900B",
//             "legalName": "Nippon India Value Fund",
//             "bseSchemeCode": "RELSEGP-GR",
//             "holding": 346033.7042925,
//             "closerate": 224.2945,
//             "balance": 1542.765,
//             "netInvestedAmt": 337500.01108464645,
//             "netUnits": 1542.765,
//             "absoluteReturn": 2.5285016081712794,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "46301",
//             "isincd": "INF204KC1378",
//             "folioNo": "488309951926",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Nippon India Silver ETF FOF(G)-Direct Plan",
//             "xirr": 11943.53,
//             "amcCode": 400025,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "RLSOAG-GR",
//             "holding": 38050.65992,
//             "closerate": 50.96,
//             "balance": 746.677,
//             "netInvestedAmt": 24999.995897298002,
//             "netUnits": 746.677,
//             "absoluteReturn": 52.202664657687045,
//             "isOutsideData": 1
//         },
//         {
//             "schemeCode": "19570",
//             "isincd": "INF966L01986",
//             "folioNo": "51012533522",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Quant ELSS Tax Saver Fund(G)-Direct Plan",
//             "xirr": 13.93,
//             "amcCode": 400010,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "QUTPDG-GR",
//             "holding": 297013.7378096,
//             "closerate": 393.5458,
//             "balance": 754.712,
//             "netInvestedAmt": 184999.8375329002,
//             "netUnits": 754.712,
//             "absoluteReturn": 60.54810737700209,
//             "isOutsideData": 1
//         },
//         {
//             "schemeCode": "19572",
//             "isincd": "INF966L01911",
//             "folioNo": "51026587482",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Quant Flexi Cap Fund(G)-Direct Plan",
//             "xirr": 18.07,
//             "amcCode": 400010,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "QUPEDG-GR",
//             "holding": 458421.408497,
//             "closerate": 102.8495,
//             "balance": 4457.206,
//             "netInvestedAmt": 349999.9885680722,
//             "netUnits": 4457.206,
//             "absoluteReturn": 25.536306620285643,
//             "isOutsideData": 1
//         },
//         {
//             "schemeCode": "48334",
//             "isincd": "INF966L01CW0",
//             "folioNo": "51099234266",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Quant Momentum Fund-Reg(G)",
//             "xirr": -1.26,
//             "amcCode": 400010,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "QUMOGP-GR",
//             "holding": 521978.328549,
//             "closerate": 13.6179,
//             "balance": 38330.31,
//             "netInvestedAmt": 524999.996304581,
//             "netUnits": 38330.31,
//             "absoluteReturn": -0.575555767019069,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "27622",
//             "isincd": "INF754K01EF3",
//             "folioNo": "91035655496",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Edelweiss Arbitrage Fund-Reg(G)",
//             "xirr": 5.48,
//             "amcCode": 400035,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "EDATGP-GR",
//             "holding": 179311.5106189,
//             "closerate": 19.9991,
//             "balance": 8965.979000000001,
//             "netInvestedAmt": 174999.9864577448,
//             "netUnits": 8965.979000000001,
//             "absoluteReturn": 2.4637282827426237,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "27622",
//             "isincd": "INF754K01EF3",
//             "folioNo": "91035655723",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Edelweiss Arbitrage Fund-Reg(G)",
//             "xirr": 5.49,
//             "amcCode": 400035,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "EDATGP-GR",
//             "holding": 307375.2474914,
//             "closerate": 19.9991,
//             "balance": 15369.454,
//             "netInvestedAmt": 299999.9793385045,
//             "netUnits": 15369.454,
//             "absoluteReturn": 2.458422886947478,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "27622",
//             "isincd": "INF754K01EF3",
//             "folioNo": "91035656472",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Edelweiss Arbitrage Fund-Reg(G)",
//             "xirr": 5.45,
//             "amcCode": 400035,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "EDATGP-GR",
//             "holding": 276772.6246714,
//             "closerate": 19.9991,
//             "balance": 13839.253999999999,
//             "netInvestedAmt": 269999.9795535115,
//             "netUnits": 13839.253999999999,
//             "absoluteReturn": 2.5083872706539383,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "46800",
//             "isincd": "INF754K01OT3",
//             "folioNo": "91036085533",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Edelweiss Gold and Silver ETF FoF-Reg(G)",
//             "xirr": 493.49,
//             "amcCode": 400035,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "EDGFRG-GR",
//             "holding": 399100.304382,
//             "closerate": 41.197,
//             "balance": 9687.606,
//             "netInvestedAmt": 199999.9910435772,
//             "netUnits": 9687.606,
//             "absoluteReturn": 99.55016112727806,
//             "isOutsideData": 0
//         },
//         {
//             "schemeCode": "31710",
//             "isincd": "INF247L01569",
//             "folioNo": "91066039522",
//             "clientName": "SHIBASISH PRAMANIK",
//             "schemeName": "Motilal Oswal ELSS Tax Saver Fund(G)-Direct Plan",
//             "xirr": -7.06,
//             "amcCode": 400042,
//             "panNumber": "AIDPP6900B",
//             "legalName": null,
//             "bseSchemeCode": "MOLTGD-GR",
//             "holding": 91067.2485174,
//             "closerate": 54.2106,
//             "balance": 1679.8790000000001,
//             "netInvestedAmt": 99999.92146208583,
//             "netUnits": 1679.8790000000001,
//             "absoluteReturn": -8.932679960226343,
//             "isOutsideData": 1
//         }
//     ],
//     "familyData": {
//         "AVOPG4248F": [
//             {
//                 "schemeCode": "21520",
//                 "isincd": "INF879O01019",
//                 "folioNo": "18291780",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Parag Parikh Flexi Cap Fund-Reg(G)",
//                 "xirr": -1.26,
//                 "amcCode": 400049,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "PP001RG-GR",
//                 "holding": 352733.0002596,
//                 "closerate": 85.1988,
//                 "balance": 4140.117,
//                 "netInvestedAmt": 353999.9726308759,
//                 "netUnits": 4140.117,
//                 "absoluteReturn": -0.35790182746623767,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "7870",
//                 "isincd": "INF205K01304",
//                 "folioNo": "31018752734",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Invesco India Largecap Fund-Reg(G)",
//                 "xirr": 6.49,
//                 "amcCode": 400021,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "RGFBL-GR",
//                 "holding": 658990.39156,
//                 "closerate": 68.17,
//                 "balance": 9666.868000000013,
//                 "netInvestedAmt": 641742.5848249651,
//                 "netUnits": 9666.868000000013,
//                 "absoluteReturn": 9.712038242100583,
//                 "isOutsideData": 1
//             },
//             {
//                 "schemeCode": "50096",
//                 "isincd": "INF226401026",
//                 "folioNo": "3771072675",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Capitalmind Flexi Cap Fund-Reg(G)",
//                 "xirr": 6.4,
//                 "amcCode": 400067,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "CMFCGP-GR",
//                 "holding": 706922.797032,
//                 "closerate": 10.1016,
//                 "balance": 69981.26999999999,
//                 "netInvestedAmt": 694500.0261623447,
//                 "netUnits": 69981.26999999999,
//                 "absoluteReturn": 1.7887358389748114,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "1495",
//                 "isincd": "INF109K01761",
//                 "folioNo": "40903165/64",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "ICICI Pru Multi-Asset Fund(G)",
//                 "xirr": 10.05,
//                 "amcCode": 400015,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "DYNMIC",
//                 "holding": 350038.0977304,
//                 "closerate": 812.6134,
//                 "balance": 430.75600000000003,
//                 "netInvestedAmt": 340500.5636506737,
//                 "netUnits": 430.75600000000003,
//                 "absoluteReturn": 2.801033272153701,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "42342",
//                 "isincd": "INF194KB1AJ8",
//                 "folioNo": "4423262/08",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Bandhan Small Cap Fund-Reg(G)",
//                 "xirr": 5.82,
//                 "amcCode": 400028,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "ID340-GR",
//                 "holding": 665373.074407,
//                 "closerate": 43.553,
//                 "balance": 15277.319000000003,
//                 "netInvestedAmt": 610984.2775094913,
//                 "netUnits": 15277.319000000003,
//                 "absoluteReturn": 8.901832485642627,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "2662",
//                 "isincd": "INF204K01GB3",
//                 "folioNo": "477319285511",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Nippon India Value Fund(G)",
//                 "xirr": 5.35,
//                 "amcCode": 400025,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": "Nippon India Value Fund",
//                 "bseSchemeCode": "RELSEGP-GR",
//                 "holding": 1285501.310795,
//                 "closerate": 224.2945,
//                 "balance": 5731.310000000003,
//                 "netInvestedAmt": 1187215.9122707222,
//                 "netUnits": 5731.310000000003,
//                 "absoluteReturn": 8.278645653956326,
//                 "isOutsideData": 1
//             },
//             {
//                 "schemeCode": "48334",
//                 "isincd": "INF966L01CW0",
//                 "folioNo": "510100589364",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Quant Momentum Fund-Reg(G)",
//                 "xirr": -7.12,
//                 "amcCode": 400010,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUMOGP-GR",
//                 "holding": 613213.5059019,
//                 "closerate": 13.6179,
//                 "balance": 45029.960999999996,
//                 "netInvestedAmt": 627000.0023370953,
//                 "netUnits": 45029.960999999996,
//                 "absoluteReturn": -2.1988032510059323,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "48334",
//                 "isincd": "INF966L01CW0",
//                 "folioNo": "510101141854",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Quant Momentum Fund-Reg(G)",
//                 "xirr": -28.66,
//                 "amcCode": 400010,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUMOGP-GR",
//                 "holding": 51460.273773,
//                 "closerate": 13.6179,
//                 "balance": 3778.8700000000003,
//                 "netInvestedAmt": 53999.99555578456,
//                 "netUnits": 3778.8700000000003,
//                 "absoluteReturn": -4.703188873711863,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "75001",
//                 "isincd": "INF966L30027",
//                 "folioNo": "71023886615",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Qsif Equity Long-Short Fund-Reg(G)",
//                 "xirr": -59.32,
//                 "amcCode": 400069,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUSLSGP-GR",
//                 "holding": 1231393.097505,
//                 "closerate": 9.565,
//                 "balance": 128739.477,
//                 "netInvestedAmt": 1299998.9917595533,
//                 "netUnits": 128739.477,
//                 "absoluteReturn": -5.277380574095295,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "27622",
//                 "isincd": "INF754K01EF3",
//                 "folioNo": "91038086981",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Edelweiss Arbitrage Fund-Reg(G)",
//                 "xirr": 5.51,
//                 "amcCode": 400035,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "EDATGP-GR",
//                 "holding": 239999.19955,
//                 "closerate": 19.9991,
//                 "balance": 12000.499999999993,
//                 "netInvestedAmt": 238000.6903921476,
//                 "netUnits": 12000.499999999993,
//                 "absoluteReturn": 0.7917745490518775,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "44630",
//                 "isincd": "INF754K01LC5",
//                 "folioNo": "91039681736",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Edelweiss US Technology Equity FOF-Reg(G)",
//                 "xirr": 5.4,
//                 "amcCode": 400035,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "EDUTRG-GR",
//                 "holding": 54408.8602062,
//                 "closerate": 33.3098,
//                 "balance": 1633.4189999999999,
//                 "netInvestedAmt": 54000.00664073877,
//                 "netUnits": 1633.4189999999999,
//                 "absoluteReturn": 0.7571361392255458,
//                 "isOutsideData": 0
//             }
//         ],
//         "AVOPG4248S": [

//             {
//                 "schemeCode": "50096",
//                 "isincd": "INF226401026",
//                 "folioNo": "3771072675",
//                 "clientName": "Shantilal",
//                 "schemeName": "Capitalmind Flexi Cap Fund-Reg(G)",
//                 "xirr": 6.4,
//                 "amcCode": 400067,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "CMFCGP-GR",
//                 "holding": 706922.797032,
//                 "closerate": 10.1016,
//                 "balance": 69981.26999999999,
//                 "netInvestedAmt": 694500.0261623447,
//                 "netUnits": 69981.26999999999,
//                 "absoluteReturn": 1.7887358389748114,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "1495",
//                 "isincd": "INF109K01761",
//                 "folioNo": "40903165/64",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "ICICI Pru Multi-Asset Fund(G)",
//                 "xirr": 10.05,
//                 "amcCode": 400015,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "DYNMIC",
//                 "holding": 350038.0977304,
//                 "closerate": 812.6134,
//                 "balance": 430.75600000000003,
//                 "netInvestedAmt": 340500.5636506737,
//                 "netUnits": 430.75600000000003,
//                 "absoluteReturn": 2.801033272153701,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "42342",
//                 "isincd": "INF194KB1AJ8",
//                 "folioNo": "4423262/08",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Bandhan Small Cap Fund-Reg(G)",
//                 "xirr": 5.82,
//                 "amcCode": 400028,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "ID340-GR",
//                 "holding": 665373.074407,
//                 "closerate": 43.553,
//                 "balance": 15277.319000000003,
//                 "netInvestedAmt": 610984.2775094913,
//                 "netUnits": 15277.319000000003,
//                 "absoluteReturn": 8.901832485642627,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "2662",
//                 "isincd": "INF204K01GB3",
//                 "folioNo": "477319285511",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Nippon India Value Fund(G)",
//                 "xirr": 5.35,
//                 "amcCode": 400025,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": "Nippon India Value Fund",
//                 "bseSchemeCode": "RELSEGP-GR",
//                 "holding": 1285501.310795,
//                 "closerate": 224.2945,
//                 "balance": 5731.310000000003,
//                 "netInvestedAmt": 1187215.9122707222,
//                 "netUnits": 5731.310000000003,
//                 "absoluteReturn": 8.278645653956326,
//                 "isOutsideData": 1
//             },
//             {
//                 "schemeCode": "48334",
//                 "isincd": "INF966L01CW0",
//                 "folioNo": "510100589364",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Quant Momentum Fund-Reg(G)",
//                 "xirr": -7.12,
//                 "amcCode": 400010,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUMOGP-GR",
//                 "holding": 613213.5059019,
//                 "closerate": 13.6179,
//                 "balance": 45029.960999999996,
//                 "netInvestedAmt": 627000.0023370953,
//                 "netUnits": 45029.960999999996,
//                 "absoluteReturn": -2.1988032510059323,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "48334",
//                 "isincd": "INF966L01CW0",
//                 "folioNo": "510101141854",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Quant Momentum Fund-Reg(G)",
//                 "xirr": -28.66,
//                 "amcCode": 400010,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUMOGP-GR",
//                 "holding": 51460.273773,
//                 "closerate": 13.6179,
//                 "balance": 3778.8700000000003,
//                 "netInvestedAmt": 53999.99555578456,
//                 "netUnits": 3778.8700000000003,
//                 "absoluteReturn": -4.703188873711863,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "75001",
//                 "isincd": "INF966L30027",
//                 "folioNo": "71023886615",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Qsif Equity Long-Short Fund-Reg(G)",
//                 "xirr": -59.32,
//                 "amcCode": 400069,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUSLSGP-GR",
//                 "holding": 1231393.097505,
//                 "closerate": 9.565,
//                 "balance": 128739.477,
//                 "netInvestedAmt": 1299998.9917595533,
//                 "netUnits": 128739.477,
//                 "absoluteReturn": -5.277380574095295,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "27622",
//                 "isincd": "INF754K01EF3",
//                 "folioNo": "91038086981",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Edelweiss Arbitrage Fund-Reg(G)",
//                 "xirr": 5.51,
//                 "amcCode": 400035,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "EDATGP-GR",
//                 "holding": 239999.19955,
//                 "closerate": 19.9991,
//                 "balance": 12000.499999999993,
//                 "netInvestedAmt": 238000.6903921476,
//                 "netUnits": 12000.499999999993,
//                 "absoluteReturn": 0.7917745490518775,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "44630",
//                 "isincd": "INF754K01LC5",
//                 "folioNo": "91039681736",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Edelweiss US Technology Equity FOF-Reg(G)",
//                 "xirr": 5.4,
//                 "amcCode": 400035,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "EDUTRG-GR",
//                 "holding": 54408.8602062,
//                 "closerate": 33.3098,
//                 "balance": 1633.4189999999999,
//                 "netInvestedAmt": 54000.00664073877,
//                 "netUnits": 1633.4189999999999,
//                 "absoluteReturn": 0.7571361392255458,
//                 "isOutsideData": 0
//             }
//         ],
//         "AVOFG4248F": [
//             {
//                 "schemeCode": "21520",
//                 "isincd": "INF879O01019",
//                 "folioNo": "18291780",
//                 "clientName": "Nishu Singh",
//                 "schemeName": "Parag Parikh Flexi Cap Fund-Reg(G)",
//                 "xirr": -1.26,
//                 "amcCode": 400049,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "PP001RG-GR",
//                 "holding": 352733.0002596,
//                 "closerate": 85.1988,
//                 "balance": 4140.117,
//                 "netInvestedAmt": 353999.9726308759,
//                 "netUnits": 4140.117,
//                 "absoluteReturn": -0.35790182746623767,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "7870",
//                 "isincd": "INF205K01304",
//                 "folioNo": "31018752734",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Invesco India Largecap Fund-Reg(G)",
//                 "xirr": 6.49,
//                 "amcCode": 400021,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "RGFBL-GR",
//                 "holding": 658990.39156,
//                 "closerate": 68.17,
//                 "balance": 9666.868000000013,
//                 "netInvestedAmt": 641742.5848249651,
//                 "netUnits": 9666.868000000013,
//                 "absoluteReturn": 9.712038242100583,
//                 "isOutsideData": 1
//             },
//             {
//                 "schemeCode": "50096",
//                 "isincd": "INF226401026",
//                 "folioNo": "3771072675",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Capitalmind Flexi Cap Fund-Reg(G)",
//                 "xirr": 6.4,
//                 "amcCode": 400067,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "CMFCGP-GR",
//                 "holding": 706922.797032,
//                 "closerate": 10.1016,
//                 "balance": 69981.26999999999,
//                 "netInvestedAmt": 694500.0261623447,
//                 "netUnits": 69981.26999999999,
//                 "absoluteReturn": 1.7887358389748114,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "1495",
//                 "isincd": "INF109K01761",
//                 "folioNo": "40903165/64",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "ICICI Pru Multi-Asset Fund(G)",
//                 "xirr": 10.05,
//                 "amcCode": 400015,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "DYNMIC",
//                 "holding": 350038.0977304,
//                 "closerate": 812.6134,
//                 "balance": 430.75600000000003,
//                 "netInvestedAmt": 340500.5636506737,
//                 "netUnits": 430.75600000000003,
//                 "absoluteReturn": 2.801033272153701,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "42342",
//                 "isincd": "INF194KB1AJ8",
//                 "folioNo": "4423262/08",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Bandhan Small Cap Fund-Reg(G)",
//                 "xirr": 5.82,
//                 "amcCode": 400028,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "ID340-GR",
//                 "holding": 665373.074407,
//                 "closerate": 43.553,
//                 "balance": 15277.319000000003,
//                 "netInvestedAmt": 610984.2775094913,
//                 "netUnits": 15277.319000000003,
//                 "absoluteReturn": 8.901832485642627,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "2662",
//                 "isincd": "INF204K01GB3",
//                 "folioNo": "477319285511",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Nippon India Value Fund(G)",
//                 "xirr": 5.35,
//                 "amcCode": 400025,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": "Nippon India Value Fund",
//                 "bseSchemeCode": "RELSEGP-GR",
//                 "holding": 1285501.310795,
//                 "closerate": 224.2945,
//                 "balance": 5731.310000000003,
//                 "netInvestedAmt": 1187215.9122707222,
//                 "netUnits": 5731.310000000003,
//                 "absoluteReturn": 8.278645653956326,
//                 "isOutsideData": 1
//             },
//             {
//                 "schemeCode": "48334",
//                 "isincd": "INF966L01CW0",
//                 "folioNo": "510100589364",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Quant Momentum Fund-Reg(G)",
//                 "xirr": -7.12,
//                 "amcCode": 400010,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUMOGP-GR",
//                 "holding": 613213.5059019,
//                 "closerate": 13.6179,
//                 "balance": 45029.960999999996,
//                 "netInvestedAmt": 627000.0023370953,
//                 "netUnits": 45029.960999999996,
//                 "absoluteReturn": -2.1988032510059323,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "48334",
//                 "isincd": "INF966L01CW0",
//                 "folioNo": "510101141854",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Quant Momentum Fund-Reg(G)",
//                 "xirr": -28.66,
//                 "amcCode": 400010,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUMOGP-GR",
//                 "holding": 51460.273773,
//                 "closerate": 13.6179,
//                 "balance": 3778.8700000000003,
//                 "netInvestedAmt": 53999.99555578456,
//                 "netUnits": 3778.8700000000003,
//                 "absoluteReturn": -4.703188873711863,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "75001",
//                 "isincd": "INF966L30027",
//                 "folioNo": "71023886615",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Qsif Equity Long-Short Fund-Reg(G)",
//                 "xirr": -59.32,
//                 "amcCode": 400069,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "QUSLSGP-GR",
//                 "holding": 1231393.097505,
//                 "closerate": 9.565,
//                 "balance": 128739.477,
//                 "netInvestedAmt": 1299998.9917595533,
//                 "netUnits": 128739.477,
//                 "absoluteReturn": -5.277380574095295,
//                 "isOutsideData": 0
//             },
//             {
//                 "schemeCode": "27622",
//                 "isincd": "INF754K01EF3",
//                 "folioNo": "91038086981",
//                 "clientName": "TANIYA GHOSH",
//                 "schemeName": "Edelweiss Arbitrage Fund-Reg(G)",
//                 "xirr": 5.51,
//                 "amcCode": 400035,
//                 "panNumber": "AVOPG4248F",
//                 "legalName": null,
//                 "bseSchemeCode": "EDATGP-GR",
//                 "holding": 239999.19955,
//                 "closerate": 19.9991,
//                 "balance": 12000.499999999993,
//                 "netInvestedAmt": 238000.6903921476,
//                 "netUnits": 12000.499999999993,
//                 "absoluteReturn": 0.7917745490518775,
//                 "isOutsideData": 0
//             }
//         ],
//     },
//     "message": "Holdings fetched successfully",
//     "status": "SUCCESS"
// }

const GlanceStats = ({ cardVariants, loginDetails, orders, mfHolding }) => {


    const getCurrentInvestmentTotal = () => {
        let investment

        if (loginDetails?.uid?.toUpperCase().includes('FAB0100')) {
            investment =
                orders.state === 'hasValue' && orders?.contents?.holdings?.length > 0
                    ? orders?.contents?.holdings
                        .reduce((sum, item) => sum + item.currentNav * item.netUnits, 0)
                    : 0
        } else {
            investment =
                mfHolding.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0
                    ? mfHolding?.contents?.mainData
                        ?.filter((item) => item?.isOutsideData === 0)
                        .reduce((sum, item) => sum + Number(item.holding), 0)
                    : 0
        }

        const total = investment

        return total.toFixed(2)
    }

    const getCurrentInvestedTotal = () => {
        let investment

        if (loginDetails?.uid?.toUpperCase().includes('FAB0100')) {
            investment =
                orders.state === 'hasValue' && orders?.contents?.holdings?.length > 0
                    ? orders?.contents?.holdings
                        .reduce((sum, item) => sum + Number(item.netInvestedAmount), 0)
                    : 0
        } else {
            investment =
                mfHolding.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0
                    ? mfHolding?.contents?.mainData
                        ?.filter((item) => item?.isOutsideData === 0)
                        .reduce((sum, item) => sum + Number(item.netInvestedAmt), 0)
                    : 0
        }

        const total = investment

        return total.toFixed(2)
    }

    const calculateParcentage = (invested, returns) => {
        const result = ((returns - invested) / invested) * 100
        if (isNaN(result) || !isFinite(result)) {
            return "0"
        }
        return result.toFixed(2)
    }


    const familyData = Object.values(mfHolding?.contents?.familyData ?? {}).map((item) => {
        return {
            clientName: item[0].clientName,
            totalCurrent: item.reduce((acc, curr) => acc + curr.holding, 0)?.toFixed(2),
            totalInvested: item.reduce((acc, curr) => acc + curr.netInvestedAmt, 0)?.toFixed(2),
            totalReturnValue: item.reduce((acc, curr) => acc + curr.holding, 0) - item.reduce((acc, curr) => acc + curr.netInvestedAmt, 0)?.toFixed(2),
            totalPercentageReturn: calculateParcentage(item.reduce((acc, curr) => acc + curr.netInvestedAmt, 0), item.reduce((acc, curr) => acc + curr.holding, 0)),
            nonFabitsAssets: item.filter((item) => item.isOutsideData === 1 && Number(item.balance) > 0 && item.isincd).reduce((acc, curr) => acc + Number(curr.holding), 0)?.toFixed(2),
        }
    })




    // Get non-fabits assets data
    const getNonFabitsAssets = useMemo(() => {
        if (mfHolding?.state === 'hasValue' && mfHolding?.contents?.mainData?.length > 0) {
            const nonFabitsAssets = mfHolding.contents.mainData.filter(
                (item) => item?.isOutsideData === 1 && Number(item?.balance) > 0 && item?.isincd,
            )

            if (nonFabitsAssets.length === 0) return null

            // Group by ISIN
            const groupedByISIN = {}
            nonFabitsAssets.forEach((item) => {
                const isin = item?.isincd
                if (!isin) return

                if (!groupedByISIN[isin]) {
                    groupedByISIN[isin] = { ...item }
                } else {
                    groupedByISIN[isin] = {
                        ...groupedByISIN[isin],
                        balance: (groupedByISIN[isin].balance || 0) + (item.balance || 0),
                        netInvestedAmt: (groupedByISIN[isin].netInvestedAmt || 0) + (item.netInvestedAmt || 0),
                        holding: (groupedByISIN[isin].holding || 0) + (item.holding || 0),
                    }
                }
            })

            const groupedAssets = Object.values(groupedByISIN)

            const totalInvested = groupedAssets.reduce(
                (sum, item) => sum + (Number(item.netInvestedAmt) || 0),
                0,
            )
            const totalCurrent = groupedAssets.reduce((sum, item) => sum + (Number(item.holding) || 0), 0)
            const returns = totalCurrent - totalInvested
            const returnsPercentage = totalInvested > 0 ? ((returns / totalInvested) * 100).toFixed(2) : 0

            return {
                assets: groupedAssets,
                totalInvested,
                totalCurrent,
                returns,
                returnsPercentage,
            }
        }
        return null
    }, [mfHolding])

    const GLANCE_STATS_DATA = [
        {
            clientName: loginDetails?.firstName + ' ' + loginDetails?.lastName,
            totalCurrent: getCurrentInvestmentTotal(),
            totalInvested: getCurrentInvestedTotal(),
            totalReturnValue: getCurrentInvestmentTotal() - getCurrentInvestedTotal(),
            totalPercentageReturn: calculateParcentage(getCurrentInvestedTotal(), getCurrentInvestmentTotal()),
            nonFabitsAssets: getNonFabitsAssets?.totalCurrent,

        },
        ...familyData,
    ]




    const [isNonFabitsExpanded, setIsNonFabitsExpanded] = useState(false)
    const [currentSlide, setCurrentSlide] = useState(0)
    const [currentDesktopSlide, setCurrentDesktopSlide] = useState(0)
    const [canScrollPrevMobile, setCanScrollPrevMobile] = useState(false)
    const [canScrollNextMobile, setCanScrollNextMobile] = useState(false)
    const [canScrollPrevDesktop, setCanScrollPrevDesktop] = useState(false)
    const [canScrollNextDesktop, setCanScrollNextDesktop] = useState(false)
    const [isDesktop, setIsDesktop] = useState(false)

    // Mobile carousel
    const [emblaRefMobile, emblaApiMobile] = useEmblaCarousel({ loop: false })

    // Desktop carousel
    const [emblaRefDesktop, emblaApiDesktop] = useEmblaCarousel({ loop: false })

    // Track screen size for responsive indicator
    useEffect(() => {
        const checkScreenSize = () => {
            setIsDesktop(window.innerWidth >= 1024)
        }

        checkScreenSize()
        window.addEventListener('resize', checkScreenSize)

        return () => {
            window.removeEventListener('resize', checkScreenSize)
        }
    }, [])

    // Track mobile carousel state
    useEffect(() => {
        if (!emblaApiMobile) return

        const updateScrollState = () => {
            setCanScrollPrevMobile(emblaApiMobile.canScrollPrev())
            setCanScrollNextMobile(emblaApiMobile.canScrollNext())
            setCurrentSlide(emblaApiMobile.selectedScrollSnap())
        }

        updateScrollState()
        emblaApiMobile.on('select', updateScrollState)
        emblaApiMobile.on('reInit', updateScrollState)

        return () => {
            emblaApiMobile.off('select', updateScrollState)
            emblaApiMobile.off('reInit', updateScrollState)
        }
    }, [emblaApiMobile])

    // Track desktop carousel state
    useEffect(() => {
        if (!emblaApiDesktop) return

        const updateScrollState = () => {
            setCanScrollPrevDesktop(emblaApiDesktop.canScrollPrev())
            setCanScrollNextDesktop(emblaApiDesktop.canScrollNext())
            setCurrentDesktopSlide(emblaApiDesktop.selectedScrollSnap())
        }

        updateScrollState()
        emblaApiDesktop.on('select', updateScrollState)
        emblaApiDesktop.on('reInit', updateScrollState)

        return () => {
            emblaApiDesktop.off('select', updateScrollState)
            emblaApiDesktop.off('reInit', updateScrollState)
        }
    }, [emblaApiDesktop])

    // Recalculate carousel height when Non-Fabits section is expanded/collapsed
    useEffect(() => {
        if (emblaApiMobile) {
            setTimeout(() => {
                emblaApiMobile.reInit()
            }, 350) // Wait for animation to complete
        }
        if (emblaApiDesktop) {
            setTimeout(() => {
                emblaApiDesktop.reInit()
            }, 350) // Wait for animation to complete
        }
    }, [isNonFabitsExpanded, emblaApiMobile, emblaApiDesktop])

    // Navigation functions
    const scrollMobilePrev = useCallback(() => {
        if (emblaApiMobile) emblaApiMobile.scrollPrev()
    }, [emblaApiMobile])

    const scrollMobileNext = useCallback(() => {
        if (emblaApiMobile) emblaApiMobile.scrollNext()
    }, [emblaApiMobile])

    const scrollDesktopPrev = useCallback(() => {
        if (emblaApiDesktop) emblaApiDesktop.scrollPrev()
    }, [emblaApiDesktop])

    const scrollDesktopNext = useCallback(() => {
        if (emblaApiDesktop) emblaApiDesktop.scrollNext()
    }, [emblaApiDesktop])

    // Navigate to specific slide
    const goToSlide = useCallback((index) => {
        if (emblaApiMobile) emblaApiMobile.scrollTo(index)
        if (emblaApiDesktop) emblaApiDesktop.scrollTo(index)
    }, [emblaApiMobile, emblaApiDesktop])

    return (
        <div>
            {/* Mobile Carousel */}
            <div className="w-full lg:hidden relative">
                <div className="overflow-hidden" ref={emblaRefMobile}>
                    <div className="flex">
                        {GLANCE_STATS_DATA.map((item, index) => (
                            <div key={index} className="min-w-0 shrink-0 grow-0 basis-full">
                                <motion.div
                                    className='rounded-[20px] border mt-2 p-5 relative'
                                    variants={cardVariants}
                                >
                                    <div className='flex justify-end items-center'>
                                        <h3 className='text-primary-300 font-medium text-sm'>
                                            {item?.clientName?.toUpperCase()}
                                        </h3>
                                    </div>

                                    <div className='h-auto flex flex-col gap-y-4 p-2'>
                                        <div className='flex flex-col justify-center items-center gap-0'>
                                            <h1 className='text-center text-[#41558D] kerning-[48px] mb-1'>
                                                <span className='text-3xl font-extrabold'> &#8377;</span>{' '}

                                                {item?.totalCurrent > 0 ? <> <span className='text-4xl font-OrelegaOne'>
                                                    {toCurrency((item?.totalCurrent?.toString()).split('.')[0])}
                                                </span>
                                                    {item?.totalCurrent?.toString().includes('.') && (
                                                        <span className='text-2xl font-OrelegaOne'>
                                                            .{toCurrency(item?.totalCurrent?.toString().split('.')[1])}
                                                        </span>
                                                    )}</> :
                                                    <span className='text-4xl font-OrelegaOne'>
                                                        0
                                                    </span>}

                                            </h1>
                                        </div>

                                        <div className='flex justify-between'>
                                            <div className='flex flex-col justify-center items-center'>
                                                <p className='text-black-500 font-semibold text-l'>
                                                    &#8377; {toCurrency((item?.totalInvested?.toString()).split('.')[0])}
                                                </p>
                                                <p className='text-[#727272] font-medium text-[14px] kerning-[20px]'>
                                                    Invested
                                                </p>
                                            </div>

                                            <div className='flex flex-col justify-center items-center w-[50%]'>
                                                <p className='text-black-500 font-semibold text-l'>
                                                    &#8377;{' '}
                                                    {toCurrency((item?.totalReturnValue?.toString()).split('.')[0])}
                                                </p>

                                                <p className='flex justify-center items-center gap-x-1 text-[#727272] font-medium text-sm text-nowrap'>
                                                    <p className='text-[#727272] font-medium text-[14px] kerning-[20px]'>
                                                        Current
                                                    </p>

                                                    {calculateParcentage(
                                                        item?.totalInvested,
                                                        item?.totalCurrent,
                                                    ) != 0 && (
                                                            <span
                                                                className={`${calculateParcentage(
                                                                    item?.totalInvested,
                                                                    item?.totalCurrent,
                                                                ) > 0
                                                                    ? 'bg-secondary-600'
                                                                    : 'bg-error-600'
                                                                    } rounded-full h-4 w-4 flex justify-center items-center`}
                                                            >
                                                                {calculateParcentage(
                                                                    item?.totalInvested,
                                                                    item?.totalCurrent,
                                                                ) > 0 ? (
                                                                    <ArrowUp className='h-4 w-3 text-white' />
                                                                ) : (
                                                                    <ArrowDown className='h-4 w-3 text-white' />
                                                                )}
                                                            </span>
                                                        )}
                                                    <span
                                                        className={`font-semibold ${calculateParcentage(
                                                            item?.totalInvested,
                                                            item?.totalCurrent,
                                                        ) > 0
                                                            ? 'text-secondary-600'
                                                            : calculateParcentage(
                                                                item?.totalInvested,
                                                                item?.totalCurrent,
                                                            ) < 0
                                                                ? 'text-error-600'
                                                                : 'text-black-600'
                                                            }`}
                                                    >
                                                        {calculateParcentage(
                                                            item?.totalInvested,
                                                            item?.totalCurrent,
                                                        )}
                                                        %
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {item?.nonFabitsAssets && (
                                        <>
                                            <div className='flex justify-end py-2'>
                                                <button
                                                    onClick={() => setIsNonFabitsExpanded(!isNonFabitsExpanded)}
                                                    className='text-primary-500 font-medium text-sm hover:text-primary-600 transition-colors'
                                                >
                                                    {isNonFabitsExpanded ? 'View less' : 'View more'}
                                                </button>
                                            </div>
                                            <div
                                                className='grid transition-[grid-template-rows,opacity] duration-300 ease-in-out'
                                                style={{
                                                    gridTemplateRows: isNonFabitsExpanded ? '1fr' : '0fr',
                                                    opacity: isNonFabitsExpanded ? 1 : 0,
                                                }}
                                            >
                                                <div className='overflow-hidden'>
                                                    <Separator className='my-4' />
                                                    <div className='mt-4 pb-2 flex justify-between items-center'>
                                                        <h3 className='text-primary-300 font-medium text-md'>
                                                            Non-Fabits Assets
                                                        </h3>
                                                        <h4 className='font-semibold leading-6 text-md'>
                                                            &#8377; {toCurrency(item?.nonFabitsAssets)}
                                                        </h4>
                                                    </div>
                                                    <p className='text-xs font-medium text-black-300'>
                                                        Please regularly update your external holdings with Fabits to ensure
                                                        accuracy.
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            {/* Desktop Carousel */}
            <div className="hidden lg:block w-full mx-2 lg:mx-0 relative">
                <div className="overflow-hidden" ref={emblaRefDesktop}>
                    <div className="flex">
                        {GLANCE_STATS_DATA.map((item, index) => (
                            <div key={index} className="min-w-0 shrink-0 grow-0 basis-full">
                                <motion.div
                                    className={`p-6 rounded-[24px] border h-auto w-full hidden lg:flex lg:flex-col lg:flex-[2]`}
                                    variants={cardVariants}
                                >
                                    <div className='flex justify-between mb-3 items-center'>
                                        <h3 className='text-primary-300 font-medium text-sm'>AT A GLANCE</h3>
                                        <h3 className='text-primary-300 font-medium text-sm'>
                                            {item?.clientName?.toUpperCase()}
                                        </h3>
                                    </div>
                                    <div className='flex flex-wrap justify-between items-end w-full'>
                                        <div>
                                            <h1 className='text-2xl text-primary-500'>
                                                <span className='text-[1.6rem] font-extrabold'>&#8377;</span>{' '}
                                                {item?.totalCurrent > 0 ? <>   <span className='font-OrelegaOne text-[2rem] tracking-[4%]'>
                                                    {toCurrency(item?.totalCurrent?.toString()).split('.')[0] || 0}
                                                </span>
                                                    {item?.totalCurrent?.toString().includes('.') && (
                                                        <span className='text-2xl font-OrelegaOne'>
                                                            .{toCurrency(item?.totalCurrent?.toString()).split('.')[1]}
                                                        </span>
                                                    )}</> : <span className='font-OrelegaOne text-[2rem] tracking-[4%]'>
                                                    0
                                                </span>}
                                            </h1>
                                            <p className='text-sm flex justify-center items-center gap-x-2 font-medium text-black-300'>
                                                Current Value
                                                <TooltipProvider delayDuration={300}>
                                                    <Tooltip>
                                                        <TooltipTrigger>
                                                            <CircleAlert
                                                                className='h-5 w-5 text-white rotate-180'
                                                                fill='#727272'
                                                            />
                                                        </TooltipTrigger>
                                                        <TooltipContent className='bg-black-500 max-w-[275px]'>
                                                            <p className='text-white'>
                                                                Investments could take up to 4 working days to reflect in your
                                                                account
                                                            </p>
                                                            <TooltipArrow />
                                                        </TooltipContent>
                                                    </Tooltip>
                                                </TooltipProvider>
                                            </p>
                                        </div>
                                        <div>
                                            <h1 className='font-semibold leading-6 text-xl'>
                                                &#8377; {toCurrency(item?.totalInvested?.toString()).split('.')[0] || 0}
                                            </h1>
                                            <p className='text-sm font-medium text-black-300'>Invested Amount</p>
                                        </div>

                                        <div>
                                            <h1 className='font-semibold leading-6 text-xl text-center'>
                                                &#8377;{' '}
                                                {toCurrency(item?.totalCurrent?.toString() - item?.totalInvested?.toString())}
                                            </h1>
                                            <div className='flex gap-x-2 justify-center items-center'>
                                                <p className='text-sm font-medium text-black-300'>Returns</p>

                                                {calculateParcentage(
                                                    item?.totalInvested,
                                                    item?.totalCurrent,
                                                ) != 0 && (
                                                        <span
                                                            className={`${calculateParcentage(
                                                                item?.totalInvested,
                                                                item?.totalCurrent,
                                                            ) > 0
                                                                ? 'bg-secondary-600'
                                                                : 'bg-error-600'
                                                                } rounded-[50%] h-5 w-5 flex justify-center items-center text-white`}
                                                        >
                                                            {calculateParcentage(
                                                                item?.totalInvested,
                                                                item?.totalCurrent,
                                                            ) > 0 ? (
                                                                <ArrowUp className='h-4 w-3' />
                                                            ) : (
                                                                <ArrowDown className='h-4 w-3' />
                                                            )}
                                                        </span>
                                                    )}

                                                <span
                                                    className={`font-semibold ${calculateParcentage(
                                                        item?.totalInvested,
                                                        item?.totalCurrent,
                                                    ) > 0
                                                        ? 'text-secondary-600'
                                                        : calculateParcentage(
                                                            item?.totalInvested,
                                                            item?.totalCurrent,
                                                        ) < 0
                                                            ? 'text-error-600'
                                                            : 'text-black-600'
                                                        }`}
                                                >
                                                    {toCurrency(
                                                        calculateParcentage(
                                                            item?.totalInvested,
                                                            item?.totalCurrent,
                                                        ),
                                                    )}
                                                    %
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {item?.nonFabitsAssets && (
                                        <>
                                            <div className='flex justify-end py-2'>
                                                <button
                                                    onClick={() => setIsNonFabitsExpanded(!isNonFabitsExpanded)}
                                                    className='text-primary-500 font-medium text-sm hover:text-primary-600 transition-colors'
                                                >
                                                    {isNonFabitsExpanded ? 'View less' : 'View more'}
                                                </button>
                                            </div>
                                            <div
                                                className='grid transition-[grid-template-rows,opacity] duration-300 ease-in-out'
                                                style={{
                                                    gridTemplateRows: isNonFabitsExpanded ? '1fr' : '0fr',
                                                    opacity: isNonFabitsExpanded ? 1 : 0,
                                                }}
                                            >
                                                <div className='overflow-hidden'>
                                                    <Separator className='my-2' />
                                                    <div className='mt-4 flex justify-between items-center'>
                                                        <h3 className='text-primary-300 font-medium text-md'>
                                                            Non-Fabits Assets
                                                        </h3>
                                                        <h4 className='font-semibold leading-6 text-md'>
                                                            &#8377; {toCurrency(item?.nonFabitsAssets)}
                                                        </h4>
                                                    </div>
                                                    <p className='text-xs font-medium text-black-300'>
                                                        Please regularly update your external holdings with Fabits to ensure
                                                        accuracy.
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* Desktop Navigation Buttons */}
                {Object.values(mfHolding?.contents?.familyData ?? {}).length > 0 && (
                    <>
                        <Button
                            variant="outline"
                            size="icon"
                            className={`absolute hidden lg:flex justify-center items-center h-8 w-8 rounded-full border-none bg-[#ECEEF4] -left-3 top-1/2 -translate-y-1/2 ${!canScrollPrevDesktop ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={!canScrollPrevDesktop}
                            onClick={scrollDesktopPrev}
                        >
                            <ChevronLeft className='h-4 w-4 text-primary-500' />
                            <span className='sr-only'>Previous slide</span>
                        </Button>
                        <Button
                            variant="outline"
                            size="icon"
                            className={`absolute hidden lg:flex justify-center items-center h-8 w-8 rounded-full border-none bg-[#ECEEF4] -right-3 top-1/2 -translate-y-1/2 ${!canScrollNextDesktop ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={!canScrollNextDesktop}
                            onClick={scrollDesktopNext}
                        >
                            <ChevronRight className='h-4 w-4 text-primary-500' />
                            <span className='sr-only'>Next slide</span>
                        </Button>
                    </>
                )}
            </div>

            {/* Carousel Indicator - Functional for both mobile and desktop */}
            {Object.values(mfHolding?.contents?.familyData ?? {}).length > 0 && <div className='flex justify-center items-center gap-2 my-2'>
                {/* Dots Indicator */}
                <div className='flex items-center gap-1'>
                    {GLANCE_STATS_DATA.map((_, dotIndex) => {
                        // Use desktop slide on desktop, mobile slide on mobile
                        const isActive = isDesktop
                            ? dotIndex === currentDesktopSlide
                            : dotIndex === currentSlide

                        return (
                            <button
                                key={dotIndex}
                                onClick={() => goToSlide(dotIndex)}
                                className={`h-1.5 w-1.5 rounded-full transition-all cursor-pointer ${isActive
                                    ? 'bg-primary-500 w-4'
                                    : 'bg-gray-300 hover:bg-gray-400'
                                    }`}
                                aria-label={`Go to slide ${dotIndex + 1}`}
                            />
                        )
                    })}
                </div>
                {/* Current Slide Text */}
                <span className='text-xs font-medium text-black-500'>
                    {isDesktop
                        ? `${currentDesktopSlide + 1}/${GLANCE_STATS_DATA.length}`
                        : `${currentSlide + 1}/${GLANCE_STATS_DATA.length}`
                    }
                </span>
            </div>}





        </div>
    )
}

export default GlanceStats